import './PrivacyPolicyPage.less';
import React, { useContext } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';
import PrivacyPolicyBackupNinja from './termsAndPolicy/PrivacyPolicyBackupNinja';
import PrivacyPolicyCCX from './termsAndPolicy/PrivacyPolicyCcx';
import PrivacyPolicyVendorExoscale from './termsAndPolicy/PrivacyPolicyVendorExoscale';

export default PrivacyPolicyPage;

/**
 * @name PrivacyPolicyPage
 * @desc PrivacyPolicyPage component.
 */
function PrivacyPolicyPage() {
    const [origin] = useQueryParam('origin', StringParam);
    const [from] = useQueryParam('from', StringParam);

    const renderContent = () => {
        switch (origin || from || window?.FEAS_ENV?.REACT_APP_CURRENT_APP) {
            case 'exoscale':
                return <PrivacyPolicyVendorExoscale />;
            case 'cm':
                return <PrivacyPolicyBackupNinja />;
            case 'ccx':
                return <PrivacyPolicyCCX />;
            case 'bn':
            default:
                return <PrivacyPolicyBackupNinja />;
        }
    };

    return <div className="PrivacyPolicyPage">{renderContent()}</div>;
}
